import * as angular from 'angular';

"use strict";

angular.module('UrlModule', [])

export default 'UrlModule';